import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { DeliverableConfiguration } from './configuration';
import { HttpClient } from '@angular/common/http';

import { DeliverableService } from './api/deliverable.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class DeliverableApiModule {
    public static forRoot(configurationFactory: () => DeliverableConfiguration): ModuleWithProviders<DeliverableApiModule> {
        return {
            ngModule: DeliverableApiModule,
            providers: [ { provide: DeliverableConfiguration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: DeliverableApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('DeliverableApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
